module.exports = __webpack_public_path__ + "img/chart-doc-icon.55a7a624.svg";